import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { FilterOptionType } from "../../types/filter-multi.type";

type FilterMultiCheckboxProps = {
  option: FilterOptionType;
  selectedValues: string[];
  handleChange: (value: string, checked: boolean | string) => void;
  stretch?: boolean;
};

export const FilterMultiItemButton = ({
  option,
  selectedValues,
  handleChange,
  stretch = false,
}: FilterMultiCheckboxProps) => {
  return (
    <div key={option.value} className={cn(stretch && "flex-1")}>
      <Button
        size="sm"
        variant="outline"
        onClick={() =>
          handleChange(option.value, !selectedValues.includes(option.value))
        }
        className={cn(
          "flex h-auto min-h-12 gap-1 border-transparent px-2 py-3 font-medium text-base hover:cursor-pointer max-md:w-full md:w-full",
          selectedValues.includes(option.value) &&
            "border-2 border-border-selected px-[calc(0.5rem-1px)] py-[calc(0.75rem-1px)]",
        )}
        type="button"
      >
        {option.label}
      </Button>
    </div>
  );
};
